import { DOCUMENT } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { ThemeService } from '@app/service/theme.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.less',
})
export class AppComponent {
  /**
   * 启动时把存过的主题落到页面上 —— 那一件事在 {@link ThemeService} 的构造函数里，
   * 所以这里注入只为**让它被造出来**，本组件不读它的任何东西。
   *
   * 放在根组件而不是 `MainComponent`：根组件在任何路由下都在（登录页、回调页都在），
   * 放 Main 里的话那几个页面不会构造它，存过玄黑的用户就只在主框架里才是深色。
   */
  private readonly theme = inject(ThemeService);

  constructor() {
    /*
     * 「测试」斜水印：开关是**构建期常量** `environment.watermark`，引导时把 `watermark` 类
     * 挂到 `<body>` 上，样式在 `src/styles.less` 里。给 body 挂类是本工程既有手法 ——
     * `ThemeService` 挂 `dark-theme` 就是同一个做法，水印的深色变体也走那条口径。
     *
     * 用 `DOCUMENT` 而不是裸的 `document`：本工程今天是**纯客户端渲染**
     * （产物 `index.html` 里 `<app-root>` 是空的，没有跑预渲染），裸的 `document` 眼下也能用；
     * 走 `DOCUMENT` 是因为它是 Angular 的正规入口，将来真开了预渲染 / SSR 也不会炸 ——
     * 那种环境里没有全局 `document`。
     *
     * 挂类发生在**引导时**，所以 JS 起来之前那一瞬页面上还没有水印。这是纯客户端渲染的通病，
     * 与水印这个开关无关；要连那一瞬都盖上，只能把类写死在 `index.html` 里，
     * 而那会让开关变成构建期改不动的东西。
     */
    const doc = inject(DOCUMENT);
    if (environment.watermark) doc.body.classList.add('watermark');
  }
}
